import axios from 'axios';

import endpoints from '../endpoints';
import { AuthService } from '../../state/auth.service';
var API_KEY;
// eslint-disable-next-line
if (process.env.REACT_APP_ENV == 'production') {
  API_KEY = process.env.REACT_APP_API_KEY;
}
// eslint-disable-next-line
else {
  API_KEY = process.env.REACT_APP_TEST_API_KEY;
}

const getHeaders = () => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `${AuthService.getToken()}`,
  };
};

export default {
  getCustomer(cancelToken) {
    return axios
      .get(`${endpoints.BILLING_BASE}/getCustomer`, {
        headers: getHeaders(),
        cancelToken,
      })
      .then(response => {
        return response;
      })
      .catch(err => {
        throw err;
      });
  },

  updateCardInfo(stripeSource) {
    return axios
      .post(
        `${endpoints.BILLING_BASE}/updateCard`,
        {
          source: stripeSource,
        },
        {
          headers: getHeaders(),
        }
      )
      .then(response => {
        return response;
      })
      .catch(err => {
        throw err;
      });
  },

  updateSubscriptionCount(product, quantity) {
    return axios
      .post(
        `${endpoints.BILLING_BASE}/updateSubCount`,
        {
          product,
          quantity,
        },
        {
          headers: getHeaders(),
        }
      )
      .then(response => {
        return response;
      })
      .catch(err => {
        throw err;
      });
  },
  getPrice(coupon, plan, isAnnualPrice) {
    return axios
      .get(
        `${endpoints.BILLING_BASE}/price`,
        {
          params: {
            coupon: coupon,
            plan: plan,
            isAnnualPrice,
          },
        },
        {
          headers: getHeaders(),
        }
      )
      .then(response => {
        return response;
      })
      .catch(err => {
        throw err;
      });
  },
  handlePurchase(
    /*payload:*/ stripeEmail,
    stripeToken,
    /*query:*/ init_amt,
    init_coupon,
    annual_amt,
    annual_coupon,
    tos,
    userDetails,
    annualPrice,
    plan
  ) {
    return axios
      .post(
        `${endpoints.BILLING_BASE}/purchase`,
        {
          stripeEmail: stripeEmail,
          stripeToken: stripeToken,
          user: userDetails,
        },
        {
          params: {
            amt: init_amt,
            coupon: init_coupon,
            a_amt: annual_amt,
            a_coupon: annual_coupon,
            tos: tos,
            annualPrice: annualPrice,
            plan: plan,
          },
          headers: getHeaders(),
        }
      )
      .then(response => {
        return response;
      })
      .catch(err => {
        throw err;
      });
  },
  handleCancellation() {
    return axios
      .post(
        `${endpoints.BILLING_BASE}/cancelSubscription`,
        {},
        {
          headers: getHeaders(),
        }
      )
      .then(response => {
        return response;
      })
      .catch(err => {
        throw err;
      });
  },
  API_KEY: API_KEY,
  // ONLY USED FOR DEV
  // makePayer() {
  //   return axios.post(`${endpoints.BILLING_BASE}/makePayer`, {
  //     headers: getHeaders()
  //   }).then(response => {
  //     return response;
  //   }).catch(err => {
  //     throw err
  //   });
  // }
};



// WEBPACK FOOTER //
// ./src/api/stripe/index.js